import copy from 'clipboard-copy';
import { arrayOf, func, string } from 'prop-types';
import React from 'react';
import { GoClippy } from 'react-icons/go';
import { Button, InputGroupAddon } from 'reactstrap';

import getDisplayName from '../../../utils/get-display-name';

function ClipboardCopyAddon({ value }) {
  return (
    <InputGroupAddon addonType="append">
      <Button
        onClick={() => copy(value)}
        className="btn-light text-muted input-group-text"
      >
        <GoClippy />
      </Button>
    </InputGroupAddon>
  );
}

ClipboardCopyAddon.propTypes = {
  value: string,
};

ClipboardCopyAddon.defaultProps = {
  value: '',
};

function withClipboardCopy(WrappedComponent) {
  function WithClipboardCopy({ addons, ...rest }) {
    return (
      <WrappedComponent addons={[...addons, ClipboardCopyAddon]} {...rest} />
    );
  }

  WithClipboardCopy.propTypes = {
    addons: arrayOf(func.isRequired),
  };

  WithClipboardCopy.defaultProps = {
    addons: [],
  };

  WithClipboardCopy.displayName = `withClipboardCopy(${getDisplayName(
    WrappedComponent,
  )})`;

  return WithClipboardCopy;
}

export default withClipboardCopy;
